import moment from 'moment'

const today = moment()

export const thresholds = [
  {
    text: 'Today',
    from: today,
    to: today
  },
  {
    text: 'Yesterday',
    from: moment(today).subtract(1, 'days'),
    to: moment(today).subtract(1, 'days')
  },
  {
    text: 'Last 7 days',
    from: moment(today).subtract(7, 'days'),
    to: moment(today).subtract(1, 'days')
  },
  {
    text: 'Last 14 days',
    from: moment(today).subtract(14, 'days'),
    to: moment(today).subtract(1, 'days')
  },
  {
    text: 'Last 28 days',
    from: moment(today).subtract(28, 'days'),
    to: moment(today).subtract(1, 'days')
  },
  {
    text: 'Last 30 days',
    from: moment(today).subtract(30, 'days'),
    to: moment(today).subtract(1, 'days')
  },
  {
    text: 'Last 90 days',
    from: moment(today).subtract(90, 'days'),
    to: moment(today).subtract(1, 'days')
  },
  {
    text: 'Last 180 days',
    from: moment(today).subtract(180, 'days'),
    to: moment(today).subtract(1, 'days')
  },
  {
    text: 'Last 365 days',
    from: moment(today).subtract(365, 'days'),
    to: moment(today).subtract(1, 'days')
  },
  {
    text: 'Last week',
    from: moment(today).subtract(1, 'week').startOf('week'),
    to: moment(today).subtract(1, 'week').endOf('week')
  },
  {
    text: 'Last month',
    from: moment(today).subtract(1, 'month').startOf('month'),
    to: moment(today).subtract(1, 'month').endOf('month')
  },
  {
    text: 'Custom...',
    from: today,
    to: today
  }
]

export const defaultThreshold = thresholds.find(threshold => threshold.text === 'Last 30 days')
